

























import { defineComponent, ref, watch } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppRoundFixedButton from '~/components/partials/App/AppRoundFixedButton.vue';
import FormPlainSelect from '~/components/partials/Form/FormPlainSelect.vue';
import { STAFF_REVIEW_SEARCH_SORT_OPTIONS } from '~/constants';

export default defineComponent({
  components: {
    AppIcon,
    FormPlainSelect,
    AppRoundFixedButton,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    total: {
      type: Number,
      required: true,
    },
    noSort: {
      type: Boolean,
      default: false,
    },
    hasFilter: {
      type: Boolean,
      default: false,
    },
    noTotal: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const inputValue = ref(props.value || STAFF_REVIEW_SEARCH_SORT_OPTIONS[0].value);

    const openFilter = () => {
      emit('open-filter');
    };

    watch(inputValue, (val) => {
      emit('input', val);
    });

    return {
      STAFF_REVIEW_SEARCH_SORT_OPTIONS,
      inputValue,
      openFilter,
    };
  },
});
